import React from 'react'
import { useDispatch } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { useCart } from 'lib/core/hooks'
import { setPaymentMethod } from 'lib/core/data/quote/paymentMethod'
import { MagentoAvailablePaymentMethod } from 'lib/types'
import { useCheckout } from 'lib/modules/checkout'
import { Option } from './components/Option'
import { Options } from './styled'

export const PaymentOptions = () => {
  const dispatch = useDispatch()
  const { cartId, cart } = useCart()
  const { paymentMethod } = useCheckout()
  const availablePaymentMethods = cart?.data?.availablePaymentMethods

  function handleChange (method: MagentoAvailablePaymentMethod) {
    const { code } = method
    if (!cartId) {
      return
    }

    dispatch(setPaymentMethod({
      cartId,
      code
    }))
  }

  return (
    <>
      <h2>
        <FormattedMessage
          id='checkout.billing.paymentInformation'
        />
      </h2>
      <Options>
        {availablePaymentMethods?.map(method => {
          const { title, code } = method

          if (code) {
            return (
              <Option
                isSelected={paymentMethod.code === code}
                key={code}
                method={method}
                onChange={handleChange}
              >
                {title}
              </Option>
            )
          } else {
            return (
              <div
                key={code}
              >
                {title} (Not supported yet)
              </div>
            )
          }
        })}
      </Options>
    </>
  )
}
